var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 15,
    height: 11,
    fill: "#13A7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15.7956 0 16.5587 0.316071 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V15C18 15.7956 17.6839 16.5587 17.1213 17.1213C16.5587 17.6839 15.7956 18 15 18H3C2.20435 18 1.44129 17.6839 0.87868 17.1213C0.316071 16.5587 0 15.7956 0 15V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H15ZM13.47 4.97L7 11.44L4.53 8.97C4.38783 8.83752 4.19978 8.7654 4.00548 8.76882C3.81118 8.77225 3.62579 8.85097 3.48838 8.98838C3.35097 9.12579 3.27225 9.31118 3.26883 9.50548C3.2654 9.69978 3.33752 9.88782 3.47 10.03L6.47 13.03C6.61063 13.1705 6.80125 13.2493 7 13.2493C7.19875 13.2493 7.38937 13.1705 7.53 13.03L14.53 6.03C14.6625 5.88782 14.7346 5.69978 14.7312 5.50548C14.7277 5.31118 14.649 5.12579 14.5116 4.98838C14.3742 4.85097 14.1888 4.77225 13.9945 4.76883C13.8002 4.7654 13.6122 4.83752 13.47 4.97Z",
    fill: "#13A7B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.715 4.08L13.02 6.01L14.775 6.905L13.89 8.655L14.78 10.405L13.01 11.3L12.705 13.23L10.76 12.925L9.375 14.305L7.985 12.905L6.055 13.225L5.745 11.28L4 10.39L4.89 8.64L4.005 6.905L5.76 6L6.065 4.085L8 4.405L9.39 3L10.775 4.385L12.715 4.08ZM8.14 6.155C7.94109 6.155 7.75032 6.23402 7.60967 6.37467C7.46902 6.51532 7.39 6.70609 7.39 6.905C7.39 7.10391 7.46902 7.29468 7.60967 7.43533C7.75032 7.57598 7.94109 7.655 8.14 7.655C8.33891 7.655 8.52968 7.57598 8.67033 7.43533C8.81098 7.29468 8.89 7.10391 8.89 6.905C8.89 6.70609 8.81098 6.51532 8.67033 6.37467C8.52968 6.23402 8.33891 6.155 8.14 6.155ZM10.64 9.655C10.4411 9.655 10.2503 9.73402 10.1097 9.87467C9.96902 10.0153 9.89 10.2061 9.89 10.405C9.89 10.6039 9.96902 10.7947 10.1097 10.9353C10.2503 11.076 10.4411 11.155 10.64 11.155C10.8389 11.155 11.0297 11.076 11.1703 10.9353C11.311 10.7947 11.39 10.6039 11.39 10.405C11.39 10.2061 11.311 10.0153 11.1703 9.87467C11.0297 9.73402 10.8389 9.655 10.64 9.655ZM7.595 11.155L11.89 6.86L11.185 6.155L6.89 10.45L7.595 11.155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSPromo);
export default __webpack_public_path__ + "static/media/ico_s_promo.33dd5fd14fbf6c45e252c9d64c8da07e.svg";
export { ForwardRef as ReactComponent };